import {connect} from 'react-redux';
import intersection from 'lodash/intersection';
import {List} from 'immutable';
import {setReturnPath} from '../actions/creators';
import {withRouter} from 'react-router';
import {Component, PropTypes} from 'react';
import {getCurrentUserIsAuthenticated, getCurrentUserRoles, getCurrentUserIsAdmin} from '../selectors';

class Authorize extends Component {
  componentDidMount() {
    const {
      isAuthenticated, currentPath, dispatch,
      roles, route, router, userIsAdmin
    } = this.props;

    if (!isAuthenticated) {
      dispatch(setReturnPath(currentPath));
      router.push('/verify-user');
    } else if (route.roles && !intersection(route.roles, roles.toArray()).length) {
      router.push('/not-authorized');
    }
  }

  render() {
    const {isAuthenticated, children, roles, route} = this.props;
    const shouldRenderChildren =
      isAuthenticated &&
      (!route.roles || intersection(route.roles, roles.toArray()).length);

    return shouldRenderChildren ? children : null;
  }
}

Authorize.propTypes = {
  children: PropTypes.element.isRequired,
  currentPath: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  roles: PropTypes.instanceOf(List).isRequired,
  route: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  userIsAdmin: PropTypes.bool.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    currentPath: ownProps.location.pathname,
    isAuthenticated: getCurrentUserIsAuthenticated(state),
    roles: getCurrentUserRoles(state),
    userIsAdmin: getCurrentUserIsAdmin(state)
  };
}

export default withRouter(connect(mapStateToProps)(Authorize));



// WEBPACK FOOTER //
// ./app/features/authentication/containers/Authorize.js